import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CreateMessageService } from './create-message.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentsResolverService implements Resolve<any> {

    constructor(
        private dataService: CreateMessageService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.dataService.getDocumentsListObservable();
    }
}
